
//https://www.telerik.com/kendo-react-ui/components/grid/globalization

interface GridMessages {
    datepicker: {
        toggleCalendar: string;
    };
    calendar: {
        today: string;
    };
    dateinput: {
        increment: string;
        decrement: string;
    };
    numerictextbox: {
        increment: string;
        decrement: string;
    };
    grid: {
        groupPanelEmpty: string;
        pagerItemsPerPage: string;
        pagerInfo: string;
        pagerFirstPage: string;
        pagerPreviousPage: string;
        pagerNextPage: string;
        pagerLastPage: string;
        pagerPage: string;
        pagerOf: string;
        pagerTotalPages: string;
        pagerItemPerPage: string;
        filterClearButton: string;
        filterEqOperator: string;
        filterNotEqOperator: string;
        filterIsNullOperator: string;
        filterIsNotNullOperator: string;
        filterIsEmptyOperator: string;
        filterIsNotEmptyOperator: string;
        filterStartsWithOperator: string;
        filterContainsOperator: string;
        filterNotContainsOperator: string;
        filterEndsWithOperator: string;
        filterGteOperator: string;
        filterGtOperator: string;
        filterLteOperator: string;
        filterLtOperator: string;
        filterIsTrue: string;
        filterIsFalse: string;
        filterBooleanAll: string;
        filterAfterOrEqualOperator: string;
        filterAfterOperator: string;
        filterBeforeOperator: string;
        filterBeforeOrEqualOperator: string;
        filterSubmitButton: string;
        filterAndLogic: string;
        filterOrLogic: string;
        filterTitle: string;
        filterChooseOperator: string;
        filterSelectedItems: string;
        filterAriaLabel: string;
        sortAscending: string;
        sortDescending: string;
        sortAriaLabel: string;
        searchPlaceholder: string;
        noRecords: string;
        filterCheckAll: string;
        groupColumn: string;
        groupExpand: string;
        groupCollapse: string;
        groupPanelAriaLabel: string;
        gridAriaLabel: string;
        ungroupColumn: string;
        detailExpand: string;
        detailCollapse: string;
    };
}

// English translations (default)
export const messagesEn: GridMessages = {
    datepicker: {
        toggleCalendar: 'Toggle calendar'
    },
    calendar: {
        today: 'Today'
    },
    dateinput: {
        increment: 'Increment value',
        decrement: 'Decrement value'
    },
    numerictextbox: {
        increment: 'Increment value',
        decrement: 'Decrement value'
    },
    grid: {
        groupPanelEmpty: 'Drag a column header and drop it here to group by that column',
        pagerItemsPerPage: 'items per page',
        pagerInfo: '{0} - {1} of {2} items',
        pagerFirstPage: 'Go to the first page',
        pagerPreviousPage: 'Go to the previous page',
        pagerNextPage: 'Go to the next page',
        pagerLastPage: 'Go to the last page',
        pagerPage: 'Page',
        pagerOf: 'of',
        pagerTotalPages: '{0}',
        pagerItemPerPage: 'items per page',
        filterClearButton: 'Clear',
        filterEqOperator: 'Is equal to',
        filterNotEqOperator: 'Is not equal to',
        filterIsNullOperator: 'Is null',
        filterIsNotNullOperator: 'Is not null',
        filterIsEmptyOperator: 'Is empty',
        filterIsNotEmptyOperator: 'Is not empty',
        filterStartsWithOperator: 'Starts with',
        filterContainsOperator: 'Contains',
        filterNotContainsOperator: 'Does not contain',
        filterEndsWithOperator: 'Ends with',
        filterGteOperator: 'Is greater than or equal to',
        filterGtOperator: 'Is greater than',
        filterLteOperator: 'Is less than or equal to',
        filterLtOperator: 'Is less than',
        filterIsTrue: 'Is true',
        filterIsFalse: 'Is false',
        filterBooleanAll: '(All)',
        filterAfterOrEqualOperator: 'Is after or equal to',
        filterAfterOperator: 'Is after',
        filterBeforeOperator: 'Is before',
        filterBeforeOrEqualOperator: 'Is before or equal to',
        filterSubmitButton: 'Filter',
        filterAndLogic: 'And',
        filterOrLogic: 'Or',
        filterTitle: 'Filter',
        filterChooseOperator: 'Choose Operator',
        filterSelectedItems: 'selected items',
        filterAriaLabel: 'Filter',
        sortAscending: 'Sort Ascending',
        sortDescending: 'Sort Descending',
        sortAriaLabel: 'Sortable',
        searchPlaceholder: 'Search',
        noRecords: 'No records available.',
        filterCheckAll: 'Check All',
        groupColumn: 'Group Column',
        groupExpand: 'Expand group',
        groupCollapse: 'Collapse Group',
        groupPanelAriaLabel: 'Group panel',
        gridAriaLabel: 'Table',
        ungroupColumn: 'Ungroup Column',
        detailExpand: 'Expand detail row',
        detailCollapse: 'Collapse detail row'
    }
};

// Norwegian translations
export const messagesNo: GridMessages = {
    datepicker: {
        toggleCalendar: 'Veksle kalender'
    },
    calendar: {
        today: 'I dag'
    },
    dateinput: {
        increment: 'Øk verdi',
        decrement: 'Reduser verdi'
    },
    numerictextbox: {
        increment: 'Øk verdi',
        decrement: 'Reduser verdi'
    },
    grid: {
        groupPanelEmpty: 'Dra en kolonneoverskrift og slipp den her for å gruppere etter den kolonnen',
        pagerItemsPerPage: 'elementer per side',
        pagerInfo: '{0} - {1} av {2} elementer',
        pagerFirstPage: 'Gå til første side',
        pagerPreviousPage: 'Gå til forrige side',
        pagerNextPage: 'Gå til neste side',
        pagerLastPage: 'Gå til siste side',
        pagerPage: 'Side',
        pagerOf: 'av',
        pagerTotalPages: '{0}',
        pagerItemPerPage: 'elementer per side',
        filterClearButton: 'Fjern',
        filterEqOperator: 'Er lik',
        filterNotEqOperator: 'Er ikke lik',
        filterIsNullOperator: 'Er null',
        filterIsNotNullOperator: 'Er ikke null',
        filterIsEmptyOperator: 'Er tom',
        filterIsNotEmptyOperator: 'Er ikke tom',
        filterStartsWithOperator: 'Starter med',
        filterContainsOperator: 'Inneholder',
        filterNotContainsOperator: 'Inneholder ikke',
        filterEndsWithOperator: 'Slutter med',
        filterGteOperator: 'Er større enn eller lik',
        filterGtOperator: 'Er større enn',
        filterLteOperator: 'Er mindre enn eller lik',
        filterLtOperator: 'Er mindre enn',
        filterIsTrue: 'Er sann',
        filterIsFalse: 'Er usann',
        filterBooleanAll: '(Alle)',
        filterAfterOrEqualOperator: 'Er etter eller lik',
        filterAfterOperator: 'Er etter',
        filterBeforeOperator: 'Er før',
        filterBeforeOrEqualOperator: 'Er før eller lik',
        filterSubmitButton: 'Filtrer',
        filterAndLogic: 'Og',
        filterOrLogic: 'Eller',
        filterTitle: 'Filter',
        filterChooseOperator: 'Velg operator',
        filterSelectedItems: 'valgte elementer',
        filterAriaLabel: 'Filter',
        sortAscending: 'Sorter stigende',
        sortDescending: 'Sorter synkende',
        sortAriaLabel: 'Sorterbar',
        searchPlaceholder: 'Søk',
        noRecords: 'Ingen poster tilgjengelig.',
        filterCheckAll: 'Velg alle',
        groupColumn: 'Gruppekolonne',
        groupExpand: 'Utvid gruppe',
        groupCollapse: 'Skjul gruppe',
        groupPanelAriaLabel: 'Gruppepanel',
        gridAriaLabel: 'Tabell',
        ungroupColumn: 'Opphev gruppering av kolonne',
        detailExpand: 'Utvid detaljrad',
        detailCollapse: 'Skjul detaljrad'
    }
};

